<template>
  <div>
    <el-dialog title="详情"
               top="5vh"
               :visible.sync="dialogVisible"
               width="700px"
               :before-close="handleClose"
               append-to-body>
      <el-row>
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>标题</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <span>{{ taskName }}</span>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0;">
        <el-col :span="12">
          <el-row>
            <el-col :span="9"
                    style="text-align: right;">
              <span>执行人</span>
            </el-col>
            <el-col :span="15"
                    style="text-align: left;padding-left: 15px;">
              <span>{{ executor }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="9"
                    style="text-align: right;">
              <span>任务编号</span>
            </el-col>
            <el-col :span="15"
                    style="text-align: left;padding-left: 15px;">
              <span>{{ taskNumber }}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px;">
        <el-col :span="12">
          <el-row>
            <el-col :span="9"
                    style="text-align: right;">
              <span>创建时间</span>
            </el-col>
            <el-col :span="15"
                    style="text-align: left;padding-left: 15px;">
              <span>{{ createTime }}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="9"
                    style="text-align: right;">
              <span>完成时间</span>
            </el-col>
            <el-col :span="15"
                    style="text-align: left;padding-left: 15px;">
              <span>{{ endTime }}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>任务描述</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <span v-html="task.CONTENT"></span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;">
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>完成描述</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <span v-html="task.EXCUTEUSERREPLY"></span>
        </el-col>
      </el-row>

      <!--评价-->

      <div style="color: #000000;font-size: 14px;margin: 15px 0 20px 0;">评价</div>
      <el-row>
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>服务态度</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <el-rate v-model="value1"
                   @change="manner"></el-rate>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0;">
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>服务质量</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <el-rate v-model="value2"
                   @change="quality"></el-rate>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>评价内容</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <el-input type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="textarea">
          </el-input>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0;">
        <el-col :span="5"
                style="text-align: right;padding-right: 15px;">
          <span>添加附件</span>
        </el-col>
        <el-col :span="19"
                style="text-align: left;">
          <el-upload class="upload-demo"
                     action="http://localhost:8080"
                     :limit='5'
                     :on-exceed="exceedUpload"
                     :auto-upload="true"
                     ref="upload"
                     :before-upload="beforeUpload "
                     :on-change='handleChange'
                     :file-list="FileList">
            <el-button type="primary"
                       size="mini">添加附件</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="warning"
                   @click="shut"
                   size="mini">直接关闭</el-button>
        <el-button v-if="!task.ISEVALUTION"
                   type="primary"
                   @click="evaluate"
                   size="mini">评价并关闭</el-button>
        <el-button @click="cancel"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "../../../util/auth";
import {
  addEvaluation,
  GetAllEventResults,
  closeTask
} from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  data() {
    return {
      task: "",
      dialogVisible: false,
      value1: null,
      value2: null,
      textarea: "",
      FileList: [],
      taskName: "", //标题
      executor: "", //执行人
      taskNumber: "", //任务编号
      createTime: "", //创建时间
      endTime: "", //完成时间
      createTimeFormat: function(time) {
        //格式化时间
        return time ? time.replace("T", " ").substr(0, 19) : "";
      },
      EResult: "",
      EvaMode: [
        {
          NAME: "签字确认"
        },
        {
          NAME: "其他"
        }
      ],
      Eva: {
        ID: "",
        TASKID: "",
        CONTENT: "",
        CREATETIME: "",
        EVALUTIONUSERID: "",
        EVALUTIONUSERNAME: "",
        SCORE: "5",
        EVALUTIONDEPTID: "",
        EVALUTIONDEPTNAME: "",
        REPLYCONTENT: "",
        TASKEXCUTEUSERNAME: "",
        TASKEXCUTEUSERID: "",
        TASKEXCUTEDEPTID: "",
        TASKEXCUTEDEPTNAME: "",
        INSTANCE: "",
        EVALUTIONCOMPANYID: "",
        EVALUTIONCOMPANYNAME: "",
        TASKEXCUTECOMPANYID: "",
        TASKEXCUTECOMPANTNAME: "",
        EVALUTIONMODE: "",
        TASKEVENTRESULT: "",
        TASKTYPE: 1,
        ITEMSCORES: [
          {
            ID: 1,
            EVALUTIONID: "",
            ITEMID: "",
            SCORE: "4",
            TASKID: ""
          },
          {
            ID: 1,
            EVALUTIONID: "",
            ITEMID: "",
            SCORE: "4",
            TASKID: ""
          }
        ]
      }
    };
  },
  created() {
    //  	var task = this.task;
  },
  methods: {
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    guid() {
      return (
        this.S4() +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        this.S4() +
        this.S4()
      );
    },
    cancel() {
      //取消
      this.dialogVisible = false;
      this.empty();
    },
    addValue() {
      var data = this.task;
      this.Eva.ID = this.guid();
      this.Eva.TASKID = data.ID;
      this.Eva.EVALUTIONUSERID = cookieUser.userId;
      this.Eva.EVALUTIONUSERNAME = cookieUser.realName;
      this.Eva.EVALUTIONDEPTID = cookieUser.departmentId;
      this.Eva.EVALUTIONDEPTNAME = cookieUser.departmentName;
      this.Eva.TASKEXCUTEUSERID =
        data.EXCUTEUSERID != null ? data.EXCUTEUSERID : "";
      this.Eva.TASKEXCUTEUSERNAME =
        data.EXCUTEUSERNAME != null ? data.EXCUTEUSERNAME : "";
      this.Eva.TASKEXCUTEDEPTID =
        data.EXCUTEDEPTID != null ? data.EXCUTEDEPTID : "";
      this.Eva.TASKEXCUTEDEPTNAME =
        data.EXCUTEDEPTNAME != null ? data.EXCUTEDEPTNAME : "";
      this.Eva.INSTANCE = data.INSTANCE != null ? data.INSTANCE : "";
      this.Eva.EVALUTIONCOMPANYID = cookieUser.companyId;
      this.Eva.EVALUTIONCOMPANYNAME = cookieUser.companyName;
      this.Eva.TASKEXCUTECOMPANYID =
        data.EXCUTECOMPANYID != null ? data.EXCUTECOMPANYID : "";
      this.Eva.TASKEXCUTECOMPANTNAME =
        data.EXCUTECOMPANYNAME != null ? data.EXCUTECOMPANYNAME : "";
    },
    evaluate() {
      //评价并关闭
      GetAllEventResults("").then(res => {
        if (res.length > 0) {
          this.EResult = res[0].NAME;
        }
      });
      var val1 = this.value1;
      var val2 = this.value2;
      if (val1 == 0 || val2 == 0) {
        this.$message({
          message: "请先评价星级",
          type: "warning"
        });
      }
      var formData = new FormData();

      var txt = this.textarea;
      this.Eva.EVALUTIONMODE = this.EvaMode[0].NAME;
      this.Eva.TASKEVENTRESULT = this.EResult;
      this.Eva.ITEMSCORES[0].SCORE = val1 * 20;
      this.Eva.ITEMSCORES[1].SCORE = val2 * 20;
      this.Eva.CONTENT = txt;
      this.Eva.SCORE = (val1 * 20 + val2 * 20) / 2;
      var fileList = this.FileList;
      formData.append("EvaInfo", JSON.stringify(this.Eva));
      if (fileList && fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          formData.append(i.toString(), fileList[i]);
        }
      }
      var a = formData.get("EvaInfo");
      console.log(JSON.parse(a), "aaa");
      //				return false
      addEvaluation(formData)
        .then(res => {
          console.log(res, "评价成功");
          this.dialogVisible = false;
          this.CloseTask(this.task);
          this.$emit('successed');
          setTimeout(() => {
            this.$store.dispatch("changeTaskSource");
          }, 500);
        })
        .catch(res => {
          console.log("Error! 评价失败. " + res);
        });
      this.empty();
    },
    shut() {
      this.CloseTask(this.task);
      this.dialogVisible = false;
      this.$emit('successed');
      setTimeout(() => {
        this.$store.dispatch("changeTaskSource");
      }, 500);
      this.empty();
    },
    CloseTask(task) {
      //关闭任务
      let TaskOrEvent = {
        TaskId: task.ID,
        UserId: cookieUser.userId,
        UserName: cookieUser.realName,
        DeptId: cookieUser.departmentId,
        DeptName: cookieUser.departmentName,
        SERVERID: task.SERVERCENTERID
      };
      closeTask(TaskOrEvent).then(res => {
        console.log(res, "关闭任务");
      });
    },
    getTask() {
      var task = this.task;
      console.log(task, "task");
      this.taskName = task.TASKNAME;
      this.executor = task.EXCUTEUSERNAME;
      this.taskNumber = task.INSTANCE;
      this.createTime = this.createTimeFormat(task.CREATETIME);
      this.endTime = this.createTimeFormat(task.COMPLETTIME);
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.empty();
    },
    empty() {
      this.value1 = null;
      this.value2 = null;
      this.textarea = "";
      this.FileList = [];
    },
    exceedUpload(file, fileList) {
      this.$message.warning("最多上传五个文件");
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.warning("上传单个文件大小不能超过 10MB!");
        return;
      }
      this.FileList.push(file);
      return false;
    },
    handleChange(file, fileList) {
      console.log(this.FileList);
    },
    manner(val) {
      console.log(val);
    },
    quality(val) {
      console.log(val);
      console.log(this.value2, "value2");
    }
  }
};
</script>

<style scoped>
</style>